import { gql } from '@apollo/client';

export const DELETE_TEMPLATE = gql`
  mutation template($id: ID!) {
    deleteTemplate(id: $id)
  }
`;
